<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "ApiSectionForm",
    props: {
        sectionData: {
            type: Object,
            default: () => ({}),
        },
    },
    validations: {
        formData: {
            name: { required },
        },
    },
    data() {
        return {
            submitted: false,
            formData: {
                id: this.sectionData.id || 0,
                name: this.sectionData.name || null,
                description: this.sectionData.description || null,
                sort: this.sectionData.sort || null,
            },
            isEditMode: !!this.sectionData.id,
        };
    },
    methods: {
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("submit", this.formData);
        },
    },
};
</script>
<template>
    <form @submit.prevent="submitForm">
        <div class="mb-3 d-flex gap-1">
            <div :style="{width: '120px'}">
                <label for="sectionName" class="form-label">Sort</label>
                <input
                    id="sectionSort"
                    v-model="formData.sort"
                    class="form-control"
                    autocomplete="off"
                    :disabled="formData.id == 0"
                    :placeholder="`${formData.id == 0 ? 'Auto' : ''}`"
                />
            </div>
            <div class="flex-grow-1">
                <label for="sectionName" class="form-label">Section Name</label>
                <input
                    type="text"
                    id="sectionName"
                    v-model="formData.name"
                    class="form-control"
                    autocomplete="off"
                    :class="{ 'is-invalid': submitted && $v.formData.name.$invalid }"
                />
                <div v-if="submitted && $v.formData.name.$invalid" class="invalid-feedback">
                    Section name is required.
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label for="sectionDescription" class="form-label">Description</label>
            <textarea
                id="sectionDescription"
                v-model="formData.description"
                autocomplete="off"
                class="form-control"
                rows="3"
            ></textarea>
        </div>
        <div class="d-flex justify-content-end gap-1">
            <button type="submit" class="btn btn-primary d-flex align-items-center gap-1">
                <i class="bx bx-save"></i> {{ isEditMode ? "Update" : "Create" }}
            </button>
            <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-1" @click="$emit('cancel')">
                <i class="bx bx-x"></i> Cancel
            </button>
        </div>
    </form>
</template>